module.exports = __webpack_public_path__ + "img/logo.3621bf73.png";